import {EventEmitter, Injectable} from '@angular/core';
import {SysConfigService} from './sys-config.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs/internal/Observable';
import {PageDTO} from '../dto/page.model';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class PageService {

  public BASE_URL = this.appConfig.getConfig('BASE_URL') + 'api/';
  private headers = new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8'
  });


  constructor(private httpClient: HttpClient, private appConfig: AppConfig) {
  }

  /** Get all pages **/
  getAllPages(): Observable<Array<PageDTO>> {
    return this.httpClient.get<Array<PageDTO>>(this.BASE_URL + 'page' + "/all")
  }
}
